// extracted by mini-css-extract-plugin
module.exports = {"root":"sf1f8"};